import {ListDefinitionsByType, ListDefinitionsState} from './list-definitions.model';
import {
    listDefinitionLoadComplete,
    listDefinitionLoadStart,
    listDefinitionUpdateState
} from './list-definitions.actions';
import {assign} from '../../../../lib/assign';
import {createReducer, on} from '@ngrx/store';
import {Display} from "../../../ladon-api-enums/WK.Ladon.Cms.Read.Model.List.Definition.Enum.Display";
import {cloneDeep} from "lodash";
import {ListDefinition} from "../../../common/model/WK.Ladon.Cms.Read.Model.List.Definition.ListDefinition";

const INITIAL_STATE: ListDefinitionsState = {
    isFetching: false,
    definitionsByType: {}
};

export const listDefinitionsReducer = createReducer(
    INITIAL_STATE,
    on(listDefinitionLoadStart, (state) => assign(state, {isFetching: true})),
    on(listDefinitionLoadComplete, (state, {definition}) => {
            // jest tylko jedno pole z wartością typu ListDefinition
            const newDefinition = assign(definition, {});
            const keys = Object.keys(newDefinition);
            if (newDefinition[keys[0]].metadataPanelDefinitions) {
                // dopisywanie do tablic z układem kolumn 'auto' - miejsca na etykietkę; ['A', 'B'] -> ['auto', 'A', 'auto', 'B']
                const metadataPanelDefinition = newDefinition[keys[0]].metadataPanelDefinitions.map(panels => {
                    const len = panels.templateColumns.length;
                    if (len === 0) { // jak nie ma kolumn to tylko 'auto'
                        return assign(panels, {templateColumns: [...panels.templateColumns, 'auto']});
                    } else {
                        for (let i = 0; i < len * 2; i++) {
                            if (i % 2 === 0) {
                                return assign(panels, {templateColumns: [...panels.templateColumns.slice(0, i), 'auto', ...panels.templateColumns.slice(i)]});
                            }
                        }
                    }
                });
                newDefinition[keys[0]] = assign(newDefinition[keys[0]], {metadataPanelDefinitions: metadataPanelDefinition});
            }
            return {
                isFetching: false,
                definitionsByType: assign(state.definitionsByType, newDefinition)
            };
        }
    ),
    on(listDefinitionUpdateState, (state, {listDefinitionType, selectedIds, selectedFilterIds}) => {
        const definition = structuredClone(state.definitionsByType[listDefinitionType]);
        definition.metadata.forEach(metadata => {
            if (metadata.displayOptions) {
                if (metadata.displayOptions.display === Display.Always) return;
                if (selectedIds.indexOf(metadata.id) >= 0) {
                    metadata.displayOptions.display = Display.Yes;
                } else {
                    metadata.displayOptions.display = Display.No;
                }
            }

            if (metadata.filterOptions) {
                if (metadata.filterOptions.display === Display.Always) return;
                if (selectedFilterIds.indexOf(metadata.id) >= 0) {
                    metadata.filterOptions.display = Display.Yes;
                } else {
                    metadata.filterOptions.display = Display.No;
                }
            }
        });
        const definitionByType = {[listDefinitionType]: definition};
        return {
            isFetching: state.isFetching,
            definitionsByType: assign(state.definitionsByType, definitionByType)
        };
    })
);
